<template>
  <OurPage
    data-cy="users-page"
    :title="$t('title.dealershipApplications._')"
    gray
    class="users-page"
  >
    <router-view />

    <FilterModal :show.sync="isShownFilterModal" />

    <SettingsModal :show.sync="isShownSettingsModal" />

    <template #header-right>
      <div class="buttons">
        <div v-if="getPermission['customer.notifications']">
          <OurButton
            v-if="!isMobileDevice"
            :text="$t('title.fleaMarket.settingsModal')"
            @click="onClickSettingsButton"
          />
          <OurButton v-else @click="onClickSettingsButton">
            <OurSvgIcon
              class="settings-icon"
              :src="icons.Settings"
              color="white"
              variant="light"
              size="md"
            />
          </OurButton>
        </div>
        <OurButton
          variant="thirdary"
          filled
          :text="$t('button.filters')"
          @click="onClickFilterButton"
        >
          <OurSvgIcon v-if="isMobileDevice" :src="icons.FilterAltFill" />
        </OurButton>
      </div>
    </template>
  </OurPage>
</template>

<script>
import { mapGetters } from "vuex";
import FilterModal from "../filter/Modal";
import SettingsModal from "@/views/settings/dealership-applications/settings/Modal.vue";

export default {
  name: "DealershipApplications",

  components: { FilterModal, SettingsModal },

  data() {
    return {
      isShownFilterModal: false,
      isShownSettingsModal: false,
    };
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    ...mapGetters("user", ["getPermission"]),

    icons: () => ({
      Settings: require("@material-symbols/svg-400/outlined/settings.svg"),
      FilterAltFill: require("@material-symbols/svg-400/outlined/filter_alt-fill.svg"),
    }),
  },

  methods: {
    onClickSettingsButton() {
      this.isShownSettingsModal = true;
    },

    onClickFilterButton() {
      this.isShownFilterModal = true;
    },
  },
};
</script>

<style lang="postcss" scoped>
.users-page {
  .buttons {
    @apply flex flex-row-reverse items-center justify-between gap-4 sm:flex-row sm:justify-start;
  }
}
</style>
